/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { useSelect, useDispatch } from '@wordpress/data';

const divsToUpdate = document.querySelectorAll(".wie-levert-wat-data-grid-wrapper")

divsToUpdate.forEach(div => {
  const data = JSON.parse(div.querySelector("pre").innerText)
  const root = ReactDOM.createRoot(div)
  root.render(<WieLevertWatDataGrid {...data} />)
  div.classList.remove("wie-levert-wat-data-grid")
})

function WieLevertWatDataGrid(props) {
  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const selectedCategory = useSelect ((select) => {
      const store =  select('lef-digitaal/wie-levert-wat');
      return store && store.getSelectedCategory();
  });

  const leveranciersData = useSelect((select) => {
    const store = select('lef-digitaal/wie-levert-wat');
	  setIsLoaded(true);
    return store && store.getLeveranciers();
  }, []);

  const searchTerm = useSelect((select) => {
    const store = select('lef-digitaal/wie-levert-wat');
    return store && store.getSearchTerm();
  }, "");

  let filteredLeveranciers = applySearchTermFilter(applyCategoryFilter(leveranciersData));

  function applyCategoryFilter(leveranciers) {
    return selectedCategory && selectedCategory.category_id
      ? leveranciers.filter((l) => l.categories.some((category) => selectedCategory.category_id == category.category_id))
      : leveranciers;
  }

  function applySearchTermFilter(leveranciers){
    return leveranciers.filter((l) => 
      { 
        return l.naam.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0 || l.beschrijving.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0 ;
      });
  }

  if (error) {
    return <div>Er ging iets mis... {error.message}</div>;
  } else if (!isLoaded) {
    return <div>Laden...</div>
  } else if (filteredLeveranciers.length > 0) {
    return (
      <div className="wie-levert-wat-data-grid">
        <div className="leveranciers">
            {filteredLeveranciers.map(leverancier => (
                <a className="leverancier" href={leverancier.url} target="_blank">
                  <div class="top">
                    <img src={leverancier.thumbnail} />
                    <h3>{leverancier.naam}</h3>
                  </div>
                  <div class="description">
                    <p>{leverancier.beschrijving}</p>
                  </div>
                </a>
            ))}
        </div>
      </div>
    )
  } else {
    return ( <div className="wie-levert-wat-data-grid">
      <p>Geen resultaten....</p>
    </div>
    );
  }
}
